import DeliveryLogin from "../pages/Delivery/Login";
import AllOrdersForDelivery from "../pages/Delivery/AllOrdersForDelivery";
import OrderDetails from "../pages/Delivery/OrderDetails";

export {
    DeliveryLogin,
    AllOrdersForDelivery,
    OrderDetails,
}